const OPEN_MODAL = 'scratch-gui/modals/OPEN_MODAL';
const CLOSE_MODAL = 'scratch-gui/modals/CLOSE_MODAL';

/* 增加护眼功能@米德 */
const EYE_CARE_SET_PERIOD = 'scratch-gui/eye-care/EYE_CARE_SET_PERIOD';
const EYE_CARE_UPDATE = 'scratch-gui/eye-care/EYE_CARE_UPDATE';
const EYE_CARE_INIT = 'scratch-gui/eye-care/EYE_CARE_INIT';

const MODAL_BACKDROP_LIBRARY = 'backdropLibrary';
const MODAL_CAMERA_CAPTURE = 'cameraCapture';
const MODAL_COSTUME_LIBRARY = 'costumeLibrary';
const MODAL_EXTENSION_LIBRARY = 'extensionLibrary';
const MODAL_LOADING_PROJECT = 'loadingProject';
const MODAL_TELEMETRY = 'telemetryModal';
const MODAL_SOUND_LIBRARY = 'soundLibrary';
const MODAL_SPRITE_LIBRARY = 'spriteLibrary';
const MODAL_SOUND_RECORDER = 'soundRecorder';
const MODAL_CONNECTION = 'connectionModal';
const MODAL_TIPS_LIBRARY = 'tipsLibrary';

/* 增加护眼功能@米德 */
const MODAL_EYE_CARE = 'eyeCare';
const EYE_CARE_WORK_START = 'eyeCareWorkStart';
const EYE_CARE_WORK_MINUTES = 'eyeCareWorkMinutes';
const EYE_CARE_PERIOD = 'eyeCarePeriod';

/* 保存作品@米德 */
const WORK_TO_MIDE_SAVER = 'workToMideSaver';

const initialState = {
    [MODAL_BACKDROP_LIBRARY]: false,
    [MODAL_CAMERA_CAPTURE]: false,
    [MODAL_COSTUME_LIBRARY]: false,
    [MODAL_EXTENSION_LIBRARY]: false,
    [MODAL_LOADING_PROJECT]: false,
    [MODAL_TELEMETRY]: false,
    [MODAL_SOUND_LIBRARY]: false,
    [MODAL_SPRITE_LIBRARY]: false,
    [MODAL_SOUND_RECORDER]: false,
    [MODAL_CONNECTION]: false,
    [MODAL_TIPS_LIBRARY]: false,

    /* 增加护眼功能@米德 护眼：状态初始数据 */
    [MODAL_EYE_CARE]: false,
    [EYE_CARE_WORK_MINUTES]: 0,
    [EYE_CARE_WORK_START]: 0,
    [EYE_CARE_PERIOD]: 60,

    /* 保存作品@米德 保存动画：状态初始数据 */
    [WORK_TO_MIDE_SAVER]: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true
        });
    case CLOSE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });

    /* 增加护眼功能@米德 */
    case EYE_CARE_INIT:
        return Object.assign({}, state, {
            [EYE_CARE_WORK_START]: new Date().getTime(),
            [EYE_CARE_WORK_MINUTES]: 0
        });
    case EYE_CARE_SET_PERIOD:
        return Object.assign({}, state, {
            [EYE_CARE_PERIOD]: action.period
        });
    case EYE_CARE_UPDATE:
        const newState = {};
        const ms = new Date().getTime() - state[EYE_CARE_WORK_START];
        if (ms >= state[EYE_CARE_PERIOD] * 60 * 1000) {
            /* 增加护眼功能@米德 时间到，打开护眼界面 */
            newState[MODAL_EYE_CARE] = true;
        } else {
            /* 增加护眼功能@米德 更新护眼时间 */
            newState[EYE_CARE_WORK_MINUTES] = Math.floor(ms / 1000 / 60);
        }
        return Object.assign({}, state, newState);

    default:
        return state;
    }
};
const openModal = function (modal) {
    return {
        type: OPEN_MODAL,
        modal: modal
    };
};
const closeModal = function (modal) {
    return {
        type: CLOSE_MODAL,
        modal: modal
    };
};
const openBackdropLibrary = function () {
    return openModal(MODAL_BACKDROP_LIBRARY);
};
const openCameraCapture = function () {
    return openModal(MODAL_CAMERA_CAPTURE);
};
const openCostumeLibrary = function () {
    return openModal(MODAL_COSTUME_LIBRARY);
};
const openExtensionLibrary = function () {
    return openModal(MODAL_EXTENSION_LIBRARY);
};
const openLoadingProject = function () {
    return openModal(MODAL_LOADING_PROJECT);
};
const openTelemetryModal = function () {
    return openModal(MODAL_TELEMETRY);
};
const openSoundLibrary = function () {
    return openModal(MODAL_SOUND_LIBRARY);
};
const openSpriteLibrary = function () {
    return openModal(MODAL_SPRITE_LIBRARY);
};
const openSoundRecorder = function () {
    return openModal(MODAL_SOUND_RECORDER);
};
const openConnectionModal = function () {
    return openModal(MODAL_CONNECTION);
};
const openTipsLibrary = function () {
    return openModal(MODAL_TIPS_LIBRARY);
};
const closeBackdropLibrary = function () {
    return closeModal(MODAL_BACKDROP_LIBRARY);
};
const closeCameraCapture = function () {
    return closeModal(MODAL_CAMERA_CAPTURE);
};
const closeCostumeLibrary = function () {
    return closeModal(MODAL_COSTUME_LIBRARY);
};
const closeExtensionLibrary = function () {
    return closeModal(MODAL_EXTENSION_LIBRARY);
};
const closeLoadingProject = function () {
    return closeModal(MODAL_LOADING_PROJECT);
};
const closeTelemetryModal = function () {
    return closeModal(MODAL_TELEMETRY);
};
const closeSpriteLibrary = function () {
    return closeModal(MODAL_SPRITE_LIBRARY);
};
const closeSoundLibrary = function () {
    return closeModal(MODAL_SOUND_LIBRARY);
};
const closeSoundRecorder = function () {
    return closeModal(MODAL_SOUND_RECORDER);
};
const closeTipsLibrary = function () {
    return closeModal(MODAL_TIPS_LIBRARY);
};
const closeConnectionModal = function () {
    return closeModal(MODAL_CONNECTION);
};

/* 保存作品@米德 开启动画效果 */
const openWorkToMideSaver = function () {
    return openModal(WORK_TO_MIDE_SAVER);
};
/* 保存作品@米德 关闭动画效果 */
const closeWorkToMideSaver = function () {
    return closeModal(WORK_TO_MIDE_SAVER);
};

/* 增加护眼功能@米德 */
/**
 * 打开护眼模态界面
 * @returns {{type, modal}} Action
 */
const openEyeCare = function () {
    return openModal(MODAL_EYE_CARE);
};

/**
 * 关闭护眼模态界面
 * @returns {{type, modal}} Action
 */
const closeEyeCare = function () {
    return closeModal(MODAL_EYE_CARE);
};

/**
 * 从State中提取数据计算护眼倒计时
 * @param {*} state 应用状态
 * @returns {number} 护眼倒计时，单位分钟
 */
const getEyeCareCountdown = state => {
    const p = state.scratchGui.modals[EYE_CARE_PERIOD];
    const m = state.scratchGui.modals[EYE_CARE_WORK_MINUTES];
    return p - m;
};

/**
 * 从State中提取护眼周期设置
 * @param {*} state 应用状态
 * @returns {*} 护眼周期设置，单位分钟
 */
const getEyeCarePeriod = state => state.scratchGui.modals[EYE_CARE_PERIOD];

/* eslint-disable valid-jsdoc */
/**
 * 设置护眼周期
 * @param period 弹出护眼界面的超时时间，单位分钟
 * @returns {{type: string, period: *}} Action
 */
/* eslint-disable valid-jsdoc */
const setEyeCarePeriod = function (period) {
    return {
        type: EYE_CARE_SET_PERIOD,
        period: period
    };
};

/**
 * 更新护眼时间，应该由一个定时器反复调用。
 * Reducer内部会检查护眼时间是否到达，如果已经到达护眼时间，则弹出护眼界面。
 * @returns {{type: string}} Action
 */
const updateEyeCare = function () {
    return {
        type: EYE_CARE_UPDATE
    };
};

/**
 * 初始化护眼功能
 * @returns {{type: string}} Action
 */
const initEyeCare = function () {
    return {
        type: EYE_CARE_INIT
    };
};

export {
    reducer as default,
    initialState as modalsInitialState,
    openBackdropLibrary,
    openCameraCapture,
    openCostumeLibrary,
    openExtensionLibrary,
    openLoadingProject,
    openSoundLibrary,
    openSpriteLibrary,
    openSoundRecorder,
    openTelemetryModal,
    openTipsLibrary,
    openConnectionModal,
    closeBackdropLibrary,
    closeCameraCapture,
    closeCostumeLibrary,
    closeExtensionLibrary,
    closeLoadingProject,
    closeSpriteLibrary,
    closeSoundLibrary,
    closeSoundRecorder,
    closeTelemetryModal,
    closeTipsLibrary,
    closeConnectionModal,

    /* 增加护眼功能@米德 */
    openEyeCare,
    getEyeCareCountdown,
    getEyeCarePeriod,
    setEyeCarePeriod,
    updateEyeCare,
    initEyeCare,
    closeEyeCare,

    /* 保存作品@米德 保存项目动画 */
    openWorkToMideSaver,
    closeWorkToMideSaver
};
